const s = require("./config.module.scss");
import { default as React, useEffect, useState } from "react";

import { MonitoringConfigDto } from "core/backend/common";
import CheckIcon from "components/checkIcon";
import { faTrash, faEdit, faSave, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import EditableRow from "./editableRow";
import ReadonlyRow from "./readonlyRow";

interface OwnProps {
    dto: MonitoringConfigDto;
    deleteConfig?: (id: number) => void;
    editConfig: (dto: MonitoringConfigDto) => void;
    cancelEditConfig?: () => void;
    pages: string[];
    files: string[];
    editDefault?: boolean;
    readOnly: boolean;
}


const Row = ({ dto, deleteConfig, editConfig, pages, files, editDefault, cancelEditConfig, readOnly }: OwnProps) => {

    const [isEdit, setEdit] = useState(editDefault);
    const [editDto, setEditDto] = useState(dto);

    return (
        dto &&
        <tr className="small">
            {isEdit ? <EditableRow dto={editDto} pages={pages} files={files} setEditDto={setEditDto} /> : <ReadonlyRow dto={dto} />}

            <td className={s.actions}>
                {readOnly
                    ? <></>
                    : isEdit
                        ? <><FontAwesomeIcon icon={faSave} style={{ marginRight: "10px" }} onClick={e => { setEdit(false); editConfig(editDto); }} /> <FontAwesomeIcon icon={faTimes} onClick={e => { setEdit(false); setEditDto(dto); if (cancelEditConfig) cancelEditConfig(); }} /></>
                        : <><FontAwesomeIcon icon={faEdit} style={{ marginRight: "10px" }} onClick={e => setEdit(true)} /> <FontAwesomeIcon icon={faTrash} onClick={e => deleteConfig && deleteConfig(dto.id)} /></>}
            </td>
        </tr>);
}

export default Row;